import React, { useCallback } from 'react';
import classnames from 'classnames';
import './TextField.scss';
export const TextField = ({ className = '', placeholder = '', value, onChange, type = 'text', required = false, id = '', }) => {
    const handleChange = useCallback((event) => {
        onChange(event);
    }, [onChange]);
    return (React.createElement("div", { className: classnames('textfield-wrapper', {
            [className]: className,
        }) },
        React.createElement("input", { className: "text-input", type: type, placeholder: placeholder, value: value, onChange: handleChange, id: id, required: required })));
};
//# sourceMappingURL=TextField.js.map